module.exports = __webpack_public_path__ + "img/beautify5.57f31517.webp";